import { render, staticRenderFns } from "./infoTable.vue?vue&type=template&id=78596ee2&scoped=true&"
import script from "./infoTable.vue?vue&type=script&lang=js&"
export * from "./infoTable.vue?vue&type=script&lang=js&"
import style0 from "./infoTable.vue?vue&type=style&index=0&id=78596ee2&lang=scss&scoped=true&"
import style1 from "./infoTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78596ee2",
  null
  
)

export default component.exports